"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CryptoSystem;
(function (CryptoSystem) {
    CryptoSystem["ECC"] = "ecc";
    CryptoSystem["RSA"] = "rsa";
})(CryptoSystem = exports.CryptoSystem || (exports.CryptoSystem = {}));
var EccCurve;
(function (EccCurve) {
    EccCurve["P_256"] = "P-256";
    EccCurve["P_384"] = "P-384";
    EccCurve["P_521"] = "P-521";
})(EccCurve = exports.EccCurve || (exports.EccCurve = {}));
var RsaSize;
(function (RsaSize) {
    RsaSize[RsaSize["B1024"] = 1024] = "B1024";
    RsaSize[RsaSize["B2048"] = 2048] = "B2048";
    RsaSize[RsaSize["B4096"] = 4096] = "B4096";
})(RsaSize = exports.RsaSize || (exports.RsaSize = {}));
var SymmAlg;
(function (SymmAlg) {
    SymmAlg["AES_CTR"] = "AES-CTR";
    SymmAlg["AES_CBC"] = "AES-CBC";
})(SymmAlg = exports.SymmAlg || (exports.SymmAlg = {}));
var SymmKeyLength;
(function (SymmKeyLength) {
    SymmKeyLength[SymmKeyLength["B128"] = 128] = "B128";
    SymmKeyLength[SymmKeyLength["B192"] = 192] = "B192";
    SymmKeyLength[SymmKeyLength["B256"] = 256] = "B256";
})(SymmKeyLength = exports.SymmKeyLength || (exports.SymmKeyLength = {}));
var HashAlg;
(function (HashAlg) {
    HashAlg["SHA_1"] = "SHA-1";
    HashAlg["SHA_256"] = "SHA-256";
    HashAlg["SHA_384"] = "SHA-384";
    HashAlg["SHA_512"] = "SHA-512";
})(HashAlg = exports.HashAlg || (exports.HashAlg = {}));
var CharSize;
(function (CharSize) {
    CharSize[CharSize["B8"] = 8] = "B8";
    CharSize[CharSize["B16"] = 16] = "B16";
})(CharSize = exports.CharSize || (exports.CharSize = {}));
var KeyUse;
(function (KeyUse) {
    KeyUse["Read"] = "read";
    KeyUse["Write"] = "write";
})(KeyUse = exports.KeyUse || (exports.KeyUse = {}));
//# sourceMappingURL=types.js.map